import React from 'react';

import Logo from '../../Logo/logo';

import NavigationItems from '../NavigationItems/navigationItems';

import classes from './sideDrawer.css'

import Aux from '../../../hoc/auxilliary';

import BackDrop from '../../UI/backdrop/backdrop';

const sideDrawer=(props)=>{
    
    let attachedClasses=[classes.SideDrawer, classes.Close];
    
    if(props.open){
        
        attachedClasses=[classes.SideDrawer, classes.Open];
    }
    
    return(
        
        <Aux>
        <BackDrop show={props.open} clicked={props.closed}/>
        <div className={attachedClasses.join(' ')} onClick={props.closed}>
        
        <div className={classes.Logo}>
            <Logo/>
        </div>
        
        <nav>
        
            <NavigationItems isLogged={props.isLogged}/>
        
        </nav>
        
        </div>
        </Aux>
    
    );
};

export default sideDrawer;


// WEBPACK FOOTER //
// ./src/components/Navigation/SideDrawer/sideDrawer.js